import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

interface ScriptTag {
  id: string;
  content: string;
  placement: string;
  display_order: number;
}

const ScriptTagsInjector = () => {
  const [injected, setInjected] = useState(false);

  useEffect(() => {
    if (injected) return;

    const inject = async () => {
      const { data } = await supabase
        .from("script_tags")
        .select("id, content, placement, display_order")
        .eq("is_active", true)
        .order("display_order", { ascending: true });

      if (!data || data.length === 0) return;

      (data as ScriptTag[]).forEach((tag) => {
        const container = document.createElement("div");
        container.innerHTML = tag.content;
        const scripts = container.querySelectorAll("script");
        const nonScripts = Array.from(container.childNodes).filter(
          (n) => !(n instanceof HTMLScriptElement)
        );

        const target =
          tag.placement === "head"
            ? document.head
            : tag.placement === "body_start"
            ? document.body
            : document.body;

        // Insert non-script elements
        nonScripts.forEach((node) => {
          if (node instanceof HTMLElement || node instanceof Text) {
            target.appendChild(node.cloneNode(true));
          }
        });

        // Re-create script elements so they execute
        scripts.forEach((originalScript) => {
          const script = document.createElement("script");
          Array.from(originalScript.attributes).forEach((attr) => {
            script.setAttribute(attr.name, attr.value);
          });
          if (originalScript.textContent) {
            script.textContent = originalScript.textContent;
          }
          target.appendChild(script);
        });
      });

      setInjected(true);
    };

    inject();
  }, [injected]);

  return null;
};

export default ScriptTagsInjector;
